<template>
	<div class="com-dialog-warp">
		<div class="com-dialog-main">
			<h5 class="com-dialog-title">{{title}}</h5>
			<p class="com-dialog-content">{{content}}</p>
			<div class="com-dialog-footer">
				<a href="javascript:;" class="com-dialog-btn" @click="cancel">{{btnCancel}}</a>
				<a href="javascript:;" class="com-dialog-btn" @click="confirm">{{btnConfirm}}</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		content: {
			type: String,
			default: ''
		},
		btnCancel: {
			type: String,
			default: ''
		},
		btnConfirm: {
			type: String,
			default: ''
		}
	},
	methods: {
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../assets/style/public.scss';
.com-dialog-warp {
	position: fixed;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 10000;
}

.com-dialog-main {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 270px;
	transform: translate(-50%, -50%);
	transform: -webkit-translate(-50%, -50%);
	-webkit-transform: -webkit-translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	background-color: #fff;
}

.com-dialog-title {
	text-align: center;
	font-weight: 400;
	margin-top: 30px;
	font-size: 18px;
	color: #333;
}

.com-dialog-content {
	margin: 15px 0 30px;
	padding: 0 10px;
	font-size: 14px;
	color: #666;
	text-align: center;
}

.com-dialog-footer {
	position: relative;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 45px;
	line-height: 45px;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	font-size: 15px;
	color: #666;
}

.com-dialog-footer:before {
	position: absolute;
	pointer-events: none;
	top: 0;
	left: 0;
	overflow: hidden;
	width: 100%;
	height: 0;
	content: '';
	border-bottom: 1px solid #f3f3f3;
}

.com-dialog-btn {
	position: relative;
	display: block;
	width: 49%;
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	flex: 1;
	text-align: center;
}

.com-dialog-footer > a:last-child {
	color: #ff552e;
}

.com-dialog-footer > a:not(:first-child):before {
	position: absolute;
	top: 0;
	left: 0;
	overflow: hidden;
	width: 0;
	height: 45px;
	content: '';
	border-left: 1px solid #f3f3f3;
}
</style>



// WEBPACK FOOTER //
// myDialog.vue?c1d14c9c